import React, { FC, useContext, useEffect } from "react";
import Button from "../../components/UI/button/GgButton";
import user2 from "../../assets/images/user2.png";
import Avatar from "../../components/UI/avatar/Avatar";
import { Link, useNavigate } from "react-router-dom";
import { IUsers } from "../../models/IUsers";
import { $public } from "../../http";
import { Context } from "../..";

interface IUser {
  data: IUsers;
  index: number;
  actionData?: any;
}

const UserCard: FC<IUser> = ({ data, index, actionData }) => {
  const { users } = useContext(Context);

  const navigate = useNavigate();

  async function selectUser() {
    const response = await users.loadOne(data._id);
    if (response) {
      users.setSelectedUser(response);
      navigate(`/admin/control/users/${data._id}`);
    }
  }

  return (
    <div className="user">
      <div className="content">
        <span className="avatar">
          <img src={$public(data.photo)} alt="avatar" />
        </span>
        <ul className="info">
          <li className="name">{data.name}</li>
          <li className="email additional">Email: {data.email}</li>
          <li className="phone additional">Phone: {data.phone}</li>
        </ul>
        <div className="count">{index}</div>
      </div>
      <div className="footer">
        <div className="applicants">
          {data.applicants.length > 0 ? (
            data.applicants.map((item: any) => {
              if (item.photo) {
                return (
                  <span className="avatar">
                    <img src={user2} alt="avatar" />
                  </span>
                );
              } else {
                return <Avatar name="Ivan" size="sm" />;
              }
            })
          ) : (
            <span className="none">
              <abbr className="none" title="Number of applicants">
                0
              </abbr>
            </span>
          )}
        </div>
        <div className="controls">
          {/* <Link onClick={selectUser}> */}
          <Button onPress={selectUser} stylesType="border" label="View" />
          {/* </Link> */}
          {/* <Button label='Delete' /> */}
        </div>
      </div>
    </div>
  );
};

export default UserCard;
